<template>
  <div v-if="getLabel() !== ''">
    <!-- eslint-disable vue/no-v-html -->
    <a
      :href="getLink()"
      class="inline-flex flex-no-wrap hover:underline"
      @click.prevent.stop="onClick"
    >
      <vue-text-highlight
        v-if="column.meta.highlight && column.meta.highlight() !== ''"
        :queries="column.meta.highlight().split(' ')"
      >
        {{ getLabel() }}
      </vue-text-highlight>
      <span
        v-else
        v-html="getLabel()"
      />
      <span
        v-if="getLabel() !== '' && isExternal"
        class="ml-1 -mt-1 text-orange-mia"
      >
        <svg
          fill="none"
          height="18"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          width="18"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3" />
        </svg>
      </span>
    </a>

    <div
      v-if="column.meta.after"
      v-html="column.meta.after(row)"
    />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script>
import get from 'lodash/get'
import TextHighlight from 'vue-text-highlight'

export default {
  name: 'MiaDatatableLinkColumn',

  components: {
    'vue-text-highlight': TextHighlight
  },

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  computed: {
    isExternal() {
      return get(this.column, 'meta.external', false)
    }
  },

  created() {
    this.ensureMetadata()
  },

  methods: {
    ensureMetadata() {
      if (this.column.meta === undefined || Object.keys(this.column.meta).length === 0) {
        console.error('[mia-datatable-link-column]: Please provide a "meta" property in your column definition with the following signature: { schema: string [, labelProp?: string|function] }.\n\n\tThe "schema" property will be used as link target. You can provide placeholders in the format :placeholder that will be replaced with the corresponding field from the row, e.g. "/users/:id", where :id will be replaced with the value of an "id" property of the row object.\n\n\tThe "labelProp" property is optional and can be used to utilize a custom property of the row object as label for the link. It defaults to the configured "field" property of the column definition. You can also provide a function with the signature "function(row: object): string" that retrieves the row as argument to compute a label by yourself.')
      }
    },

    getLabel() {
      const { labelProp } = this.column.meta

      if (labelProp === undefined) {
        return this.row[this.column.field]
      }

      if (typeof labelProp === 'function') {
        return labelProp(this.row)
      }

      if (this.row[labelProp] === undefined) {
        console.error(`[mia-datatable-link-column]: The property "${labelProp}" defined as labelProp does not exist on the row object.`)
        return ''
      }

      return this.row[labelProp]
    },

    getLink() {
      let template

      if (typeof this.column.meta.schema === 'function') {
        template = this.column.meta.schema(this.row)
      } else {
        template = this.column.meta.schema
      }

      // Extract all placeholders
      const parts = template.match(/:\w+/g)

      if (parts === null) {
        return template
      }

      parts
        // Remove the colon
        .map(placeholder => placeholder.replace(':', ''))
        // Apply each placeholder as replacement to the template
        .forEach((placeholder) => {
          if (this.row[placeholder] === undefined) {
            console.error(`[mia-datatable-link-column]: The placeholder ":${placeholder}" does not exist as property on the row object.`)
            return
          }

          template = template.replace(new RegExp(`:${placeholder}`, 'g'), this.row[placeholder])
        })

      return template
    },

    onClick() {
      const beforeCallback = get(this.column, 'meta.before', () => {})

      beforeCallback(this.row, this.getLink())
      this.$nextTick(() => {
        if (this.isExternal) {
          window.open(this.getLink())
        } else {
          this.$router.push(this.getLink())
        }
      })
    }
  }
}
</script>
